import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouterOutlet, provideRouter } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { routes } from '@app/app.routes';
import { ExperimentModule } from '@components/experiment/experiment.module';
import { ExperimentCreateModule } from './components/experiment-create/experiment-create.module';
import { SidenavModule } from '@components/sidenav/sidenav.module';

@NgModule({
    declarations: [AppComponent],
    providers: [
        provideAnimations(),
        provideRouter(routes)
    ],
    imports: [
        BrowserModule,
        CommonModule,
        ExperimentModule,
        ExperimentCreateModule,
        HttpClientModule,
        ReactiveFormsModule,
        SidenavModule,
        RouterOutlet
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }